import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const hexToRgb = (hex) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
};

const ThemeProvider = ({ children }) => {
  useEffect(() => {
    axios.get(`${API}/public/theme`).then(res => {
      const { primary, accent, secondary } = res.data;
      const root = document.documentElement;
      if (primary) root.style.setProperty('--color-primary', hexToRgb(primary));
      if (accent) root.style.setProperty('--color-accent', hexToRgb(accent));
      if (secondary) root.style.setProperty('--color-secondary', hexToRgb(secondary));
      // Store hex values for components that need them directly
      if (primary) root.style.setProperty('--theme-primary-hex', primary);
      if (accent) root.style.setProperty('--theme-accent-hex', accent);
    }).catch(() => {});
  }, []);

  return children;
};

export default ThemeProvider;
